module.exports = {
	"active_symbols": [
		{
			"allow_forward_starting": 1,
			"display_name": "Dutch Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "europe_africa",
			"submarket_display_name": "Europe/Africa",
			"symbol": "AEX",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Australian Index",
			"exchange_is_open": 0,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "asia_oceania",
			"submarket_display_name": "Asia/Oceania",
			"symbol": "AS51",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Belgian Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "europe_africa",
			"submarket_display_name": "Europe/Africa",
			"symbol": "BFX",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Bombay Index",
			"exchange_is_open": 0,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "asia_oceania",
			"submarket_display_name": "Asia/Oceania",
			"symbol": "BSESENSEX30",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Airbus",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "ge_otc_stock",
			"submarket_display_name": "Germany",
			"symbol": "DEAIR",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Allianz",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "ge_otc_stock",
			"submarket_display_name": "Germany",
			"symbol": "DEALV",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "BMW",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "ge_otc_stock",
			"submarket_display_name": "Germany",
			"symbol": "DEBMW",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Daimler",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "ge_otc_stock",
			"submarket_display_name": "Germany",
			"symbol": "DEDAI",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Deutsche Bank",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "ge_otc_stock",
			"submarket_display_name": "Germany",
			"symbol": "DEDBK",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Novartis",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "ge_otc_stock",
			"submarket_display_name": "Germany",
			"symbol": "DENOT",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "SAP",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "ge_otc_stock",
			"submarket_display_name": "Germany",
			"symbol": "DESAP",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Siemens",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "ge_otc_stock",
			"submarket_display_name": "Germany",
			"symbol": "DESIE",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Dubai Index",
			"exchange_is_open": 0,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "middle_east",
			"submarket_display_name": "Middle East",
			"symbol": "DFMGI",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "French Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "europe_africa",
			"submarket_display_name": "Europe/Africa",
			"symbol": "FCHI",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "German Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "europe_africa",
			"submarket_display_name": "Europe/Africa",
			"symbol": "GDAXI",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Hong Kong Index",
			"exchange_is_open": 0,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "asia_oceania",
			"submarket_display_name": "Asia/Oceania",
			"symbol": "HSI",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Bharti Airtel",
			"exchange_is_open": 0,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "india_otc_stock",
			"submarket_display_name": "India",
			"symbol": "INBHARTIARTL",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Maruti Suzuki",
			"exchange_is_open": 0,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "india_otc_stock",
			"submarket_display_name": "India",
			"symbol": "INMARUTI",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Reliance Industries",
			"exchange_is_open": 0,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "india_otc_stock",
			"submarket_display_name": "India",
			"symbol": "INRIL",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Tata Steel",
			"exchange_is_open": 0,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "india_otc_stock",
			"submarket_display_name": "India",
			"symbol": "INTATASTEEL",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Irish Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "europe_africa",
			"submarket_display_name": "Europe/Africa",
			"symbol": "ISEQ",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Jakarta Index",
			"exchange_is_open": 0,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.001",
			"submarket": "asia_oceania",
			"submarket_display_name": "Asia/Oceania",
			"symbol": "JCI",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Japanese Index",
			"exchange_is_open": 0,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "asia_oceania",
			"submarket_display_name": "Asia/Oceania",
			"symbol": "N225",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Norwegian Index",
			"exchange_is_open": 0,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "europe_africa",
			"submarket_display_name": "Europe/Africa",
			"symbol": "OBX",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Dutch OTC Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "otc_index",
			"submarket_display_name": "OTC Indices",
			"symbol": "OTC_AEX",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Australian OTC Index",
			"exchange_is_open": 0,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "otc_index",
			"submarket_display_name": "OTC Indices",
			"symbol": "OTC_AS51",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Belgian OTC Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "otc_index",
			"submarket_display_name": "OTC Indices",
			"symbol": "OTC_BFX",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Istanbul OTC Index",
			"exchange_is_open": 0,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "otc_index",
			"submarket_display_name": "OTC Indices",
			"symbol": "OTC_BIST100",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Bombay OTC Index",
			"exchange_is_open": 0,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "otc_index",
			"submarket_display_name": "OTC Indices",
			"symbol": "OTC_BSESENSEX30",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Wall Street OTC Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "otc_index",
			"submarket_display_name": "OTC Indices",
			"symbol": "OTC_DJI",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "French OTC Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "otc_index",
			"submarket_display_name": "OTC Indices",
			"symbol": "OTC_FCHI",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "UK OTC Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "otc_index",
			"submarket_display_name": "OTC Indices",
			"symbol": "OTC_FTSE",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "German OTC Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "otc_index",
			"submarket_display_name": "OTC Indices",
			"symbol": "OTC_GDAXI",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Hong Kong OTC Index",
			"exchange_is_open": 0,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "otc_index",
			"submarket_display_name": "OTC Indices",
			"symbol": "OTC_HSI",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "US Tech OTC Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "otc_index",
			"submarket_display_name": "OTC Indices",
			"symbol": "OTC_IXIC",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Japanese OTC Index",
			"exchange_is_open": 0,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "otc_index",
			"submarket_display_name": "OTC Indices",
			"symbol": "OTC_N225",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "US OTC Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "otc_index",
			"submarket_display_name": "OTC Indices",
			"symbol": "OTC_SPC",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Bear Market Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "volidx",
			"market_display_name": "Volatility Indices",
			"pip": "0.0001",
			"submarket": "random_daily",
			"submarket_display_name": "Daily Reset Indices",
			"symbol": "RDBEAR",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Bull Market Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "volidx",
			"market_display_name": "Volatility Indices",
			"pip": "0.0001",
			"submarket": "random_daily",
			"submarket_display_name": "Daily Reset Indices",
			"symbol": "RDBULL",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Volatility 10 Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "volidx",
			"market_display_name": "Volatility Indices",
			"pip": "0.001",
			"submarket": "random_index",
			"submarket_display_name": "Continuous Indices",
			"symbol": "R_10",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Volatility 100 Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "volidx",
			"market_display_name": "Volatility Indices",
			"pip": "0.01",
			"submarket": "random_index",
			"submarket_display_name": "Continuous Indices",
			"symbol": "R_100",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Volatility 25 Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "volidx",
			"market_display_name": "Volatility Indices",
			"pip": "0.001",
			"submarket": "random_index",
			"submarket_display_name": "Continuous Indices",
			"symbol": "R_25",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Volatility 50 Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "volidx",
			"market_display_name": "Volatility Indices",
			"pip": "0.0001",
			"submarket": "random_index",
			"submarket_display_name": "Continuous Indices",
			"symbol": "R_50",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Volatility 75 Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "volidx",
			"market_display_name": "Volatility Indices",
			"pip": "0.0001",
			"submarket": "random_index",
			"submarket_display_name": "Continuous Indices",
			"symbol": "R_75",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "US Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "americas",
			"submarket_display_name": "Americas",
			"symbol": "SPC",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Swiss Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "europe_africa",
			"submarket_display_name": "Europe/Africa",
			"symbol": "SSMI",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Singapore Index",
			"exchange_is_open": 0,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "asia_oceania",
			"submarket_display_name": "Asia/Oceania",
			"symbol": "STI",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "South African Index",
			"exchange_is_open": 0,
			"is_trading_suspended": 0,
			"market": "indices",
			"market_display_name": "Indices",
			"pip": "0.01",
			"submarket": "europe_africa",
			"submarket_display_name": "Europe/Africa",
			"symbol": "TOP40",
			"symbol_type": "stockindex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Barclays",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "uk_otc_stock",
			"submarket_display_name": "UK",
			"symbol": "UKBARC",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "British American Tobacco",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "uk_otc_stock",
			"submarket_display_name": "UK",
			"symbol": "UKBATS",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "BP",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "uk_otc_stock",
			"submarket_display_name": "UK",
			"symbol": "UKBP",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "HSBC",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "uk_otc_stock",
			"submarket_display_name": "UK",
			"symbol": "UKHSBA",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Lloyds Bank",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "uk_otc_stock",
			"submarket_display_name": "UK",
			"symbol": "UKLLOY",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Rio Tinto",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "uk_otc_stock",
			"submarket_display_name": "UK",
			"symbol": "UKRIO",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Standard Chartered",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "uk_otc_stock",
			"submarket_display_name": "UK",
			"symbol": "UKSTAN",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Tesco",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "uk_otc_stock",
			"submarket_display_name": "UK",
			"symbol": "UKTSCO",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Apple",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USAAPL",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Alibaba",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USALIBA",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "American Express",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USAMX",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Amazon.com",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USAMZN",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Boeing",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USBNG",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Berkshire Hathaway",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USBRKSHR",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Caterpillar",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USCAT",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Citigroup",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USCT",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Electronic Arts",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USEA",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Facebook",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USFB",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Goldman Sachs",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USGLDSCH",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Alphabet",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USGOOG",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "IBM",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USIBM",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Johnson & Johnson",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USJNJ",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "MasterCard",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USMA",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "McDonald's",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USMCDON",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Microsoft",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USMSFT",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "PepsiCo",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USPEP",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Procter & Gamble",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USPG",
			"symbol_type": "individualstock"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Exxon Mobil",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "stocks",
			"market_display_name": "OTC Stocks",
			"pip": "0.01",
			"submarket": "us_otc_stock",
			"submarket_display_name": "US",
			"symbol": "USXOM",
			"symbol_type": "individualstock"
		},
		{
			"display_name": "AUD Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.001",
			"submarket": "smart_fx",
			"submarket_display_name": "Smart FX",
			"symbol": "WLDAUD",
			"symbol_type": "smart_fx"
		},
		{
			"display_name": "EUR Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.001",
			"submarket": "smart_fx",
			"submarket_display_name": "Smart FX",
			"symbol": "WLDEUR",
			"symbol_type": "smart_fx"
		},
		{
			"display_name": "GBP Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.001",
			"submarket": "smart_fx",
			"submarket_display_name": "Smart FX",
			"symbol": "WLDGBP",
			"symbol_type": "smart_fx"
		},
		{
			"display_name": "USD Index",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.001",
			"submarket": "smart_fx",
			"submarket_display_name": "Smart FX",
			"symbol": "WLDUSD",
			"symbol_type": "smart_fx"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "AUD/CAD",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.00001",
			"submarket": "minor_pairs",
			"submarket_display_name": "Minor Pairs",
			"symbol": "frxAUDCAD",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "AUD/CHF",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.00001",
			"submarket": "minor_pairs",
			"submarket_display_name": "Minor Pairs",
			"symbol": "frxAUDCHF",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "AUD/JPY",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.001",
			"submarket": "major_pairs",
			"submarket_display_name": "Major Pairs",
			"symbol": "frxAUDJPY",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "AUD/NZD",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.00001",
			"submarket": "minor_pairs",
			"submarket_display_name": "Minor Pairs",
			"symbol": "frxAUDNZD",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "AUD/PLN",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.0001",
			"submarket": "minor_pairs",
			"submarket_display_name": "Minor Pairs",
			"symbol": "frxAUDPLN",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "AUD/USD",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.00001",
			"submarket": "major_pairs",
			"submarket_display_name": "Major Pairs",
			"symbol": "frxAUDUSD",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Oil/USD",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "commodities",
			"market_display_name": "Commodities",
			"pip": "0.01",
			"submarket": "energy",
			"submarket_display_name": "Energy",
			"symbol": "frxBROUSD",
			"symbol_type": "commodities"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "EUR/AUD",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.00001",
			"submarket": "major_pairs",
			"submarket_display_name": "Major Pairs",
			"symbol": "frxEURAUD",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "EUR/CAD",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.00001",
			"submarket": "major_pairs",
			"submarket_display_name": "Major Pairs",
			"symbol": "frxEURCAD",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "EUR/CHF",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.00001",
			"submarket": "major_pairs",
			"submarket_display_name": "Major Pairs",
			"symbol": "frxEURCHF",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "EUR/GBP",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.00001",
			"submarket": "major_pairs",
			"submarket_display_name": "Major Pairs",
			"symbol": "frxEURGBP",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "EUR/JPY",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.001",
			"submarket": "major_pairs",
			"submarket_display_name": "Major Pairs",
			"symbol": "frxEURJPY",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "EUR/NZD",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.00001",
			"submarket": "minor_pairs",
			"submarket_display_name": "Minor Pairs",
			"symbol": "frxEURNZD",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "EUR/USD",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.00001",
			"submarket": "major_pairs",
			"submarket_display_name": "Major Pairs",
			"symbol": "frxEURUSD",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "GBP/AUD",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.00001",
			"submarket": "major_pairs",
			"submarket_display_name": "Major Pairs",
			"symbol": "frxGBPAUD",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "GBP/CAD",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.00001",
			"submarket": "minor_pairs",
			"submarket_display_name": "Minor Pairs",
			"symbol": "frxGBPCAD",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "GBP/CHF",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.00001",
			"submarket": "minor_pairs",
			"submarket_display_name": "Minor Pairs",
			"symbol": "frxGBPCHF",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "GBP/JPY",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.001",
			"submarket": "major_pairs",
			"submarket_display_name": "Major Pairs",
			"symbol": "frxGBPJPY",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "GBP/NOK",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.0001",
			"submarket": "minor_pairs",
			"submarket_display_name": "Minor Pairs",
			"symbol": "frxGBPNOK",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "GBP/NZD",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.00001",
			"submarket": "minor_pairs",
			"submarket_display_name": "Minor Pairs",
			"symbol": "frxGBPNZD",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "GBP/PLN",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.0001",
			"submarket": "minor_pairs",
			"submarket_display_name": "Minor Pairs",
			"symbol": "frxGBPPLN",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "GBP/USD",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.0001",
			"submarket": "major_pairs",
			"submarket_display_name": "Major Pairs",
			"symbol": "frxGBPUSD",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "NZD/JPY",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.001",
			"submarket": "minor_pairs",
			"submarket_display_name": "Minor Pairs",
			"symbol": "frxNZDJPY",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "NZD/USD",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.00001",
			"submarket": "minor_pairs",
			"submarket_display_name": "Minor Pairs",
			"symbol": "frxNZDUSD",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "USD/CAD",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.00001",
			"submarket": "major_pairs",
			"submarket_display_name": "Major Pairs",
			"symbol": "frxUSDCAD",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "USD/CHF",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.00001",
			"submarket": "major_pairs",
			"submarket_display_name": "Major Pairs",
			"symbol": "frxUSDCHF",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "USD/JPY",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.001",
			"submarket": "major_pairs",
			"submarket_display_name": "Major Pairs",
			"symbol": "frxUSDJPY",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "USD/MXN",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.0001",
			"submarket": "minor_pairs",
			"submarket_display_name": "Minor Pairs",
			"symbol": "frxUSDMXN",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "USD/NOK",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.00001",
			"submarket": "minor_pairs",
			"submarket_display_name": "Minor Pairs",
			"symbol": "frxUSDNOK",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "USD/PLN",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.0001",
			"submarket": "minor_pairs",
			"submarket_display_name": "Minor Pairs",
			"symbol": "frxUSDPLN",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "USD/SEK",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "forex",
			"market_display_name": "Forex",
			"pip": "0.00001",
			"submarket": "minor_pairs",
			"submarket_display_name": "Minor Pairs",
			"symbol": "frxUSDSEK",
			"symbol_type": "forex"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Silver/USD",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "commodities",
			"market_display_name": "Commodities",
			"pip": "0.0001",
			"submarket": "metals",
			"submarket_display_name": "Metals",
			"symbol": "frxXAGUSD",
			"symbol_type": "commodities"
		},
		{
			"allow_forward_starting": 1,
			"display_name": "Gold/USD",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "commodities",
			"market_display_name": "Commodities",
			"pip": "0.01",
			"submarket": "metals",
			"submarket_display_name": "Metals",
			"symbol": "frxXAUUSD",
			"symbol_type": "commodities"
		},
		{
			"display_name": "Palladium/USD",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "commodities",
			"market_display_name": "Commodities",
			"pip": "0.01",
			"submarket": "metals",
			"submarket_display_name": "Metals",
			"symbol": "frxXPDUSD",
			"symbol_type": "commodities"
		},
		{
			"display_name": "Platinum/USD",
			"exchange_is_open": 1,
			"is_trading_suspended": 0,
			"market": "commodities",
			"market_display_name": "Commodities",
			"pip": "0.01",
			"submarket": "metals",
			"submarket_display_name": "Metals",
			"symbol": "frxXPTUSD",
			"symbol_type": "commodities"
		}
	],
	"echo_req": {
		"active_symbols": "brief"
	},
	"msg_type": "active_symbols"
};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Markets/active_symbols.json
// module id = 135
// module chunks = 0